// Job application statuses that precede a submission. An application that
// already has a COMPLETED submission must not be moved back to any of these
// (the API rejects it); the UI offers "Back to Submitted" instead.
export const PRE_SUBMISSION_STATUSES = [
  'APPLIED',
  'CALLED',
  'EMAILED',
  'KEEP',
  'CONTACT_LATER',
  'CALL_SCHEDULED',
  'WEB_INPERSON_SCREENED',
];

export const DECLINE_STATUSES = ['CLIENT_DECLINE', 'CANDIDATE_DECLINE'];

export const hasCompletedSubmission = (application: any): boolean =>
  application?.submission?.status === 'COMPLETED';

// Pre-submission status but a completed submission exists (stuck state).
export const isStuckPreSubmission = (application: any): boolean =>
  PRE_SUBMISSION_STATUSES.includes(application?.JobAppStatus) &&
  hasCompletedSubmission(application);

// Client/candidate decline on an application that has a submission.
export const isDeclinedWithSubmission = (application: any): boolean =>
  DECLINE_STATUSES.includes(application?.JobAppStatus) &&
  application?.submission !== null &&
  application?.submission !== undefined;
